export default __webpack_public_path__ + "static/media/paymentCash.f5698990.png";